<template>

  <ul :class="classes">

	<li v-if="allHidden&&!showHidden2&&level===0">You have hidden all your results, toggle "Show hidden" on to see them.</li>

    <li
		v-for="(listItem, listIndex) in list" 
        :key="listIndex"
		:class="{ highlighted: listItem.key === highlighted || listItem.key === highlighted2, highlighted2: listItem.key === highlighted2 }"
	>

		<span :class="{hide:!!listItem[hide]}" v-if="!listItem[hide]||!!showHidden">
			<span v-html="listItem[label]" />
			<font-awesome-icon icon="binoculars" :title="'Fetch PAA for '+listItem[label]" :style="{ color: '#3b445b' }" v-if="!readOnly&&((!listItem[children]||listItem[children].length===0)&&finalActionName!=='')&&showBincolulars" @click="(!listItem[children]||listItem[children].length===0)&&finalAction(listItem)" />
			<font-awesome-icon icon="eye-slash" :style="{ color: '#3b445b' }" title="Hide from export" v-if="!listItem[hide]&&!listItem.parentHidden&&showFinalAction2" @click="finalAction2(listItem,true)" class="eyed" />
			<font-awesome-icon icon="eye" :style="{ color: '#3b445b' }" title="Un-hide from export" v-if="listItem[hide]&&!listItem.parentHidden&&showFinalAction2" @click="finalAction2(listItem,false)" class="eyed" />
			<font-awesome-icon icon="highlighter" :style="{ color: '#3b445b' }" title="Highlight" @click="finalAction3(listItem)" :class="{selected:listItem.key === highlighted}" v-if="listItem.key !== highlighted2" />
			<a :href="googleURL+'&q='+encodeURIComponent(listItem[label])" target="_blank" v-if="googleURL"><font-awesome-icon icon="search" :style="{ color: '#3b445b' }" title="SERP"  @click="finalAction2(listItem,false)"  /></a>
		</span>

		<IndentList 
			v-if="listItem[children]&&!listItem[hide]" 
			:children="children" 
			:label="label" 
			:list="listItem[children]" 
			:highlighted="highlighted"
			:highlighted2="highlighted2"
			@finalAction="finalAction" 
			:finalActionName="finalActionName" 
			@finalAction2="finalAction2" 
			:finalAction2Name="finalAction2Name" 
			@finalAction3="finalAction3" 
			:finalAction3Name="finalAction3Name" 
			:level="level+1" 
			:class="{hide:!!listItem[hide]}"
			:googleURL="googleURL"
			:showHidden="showHidden"
			:subTabId="subTabId"
			:readOnly="readOnly"
			:showBincolulars="showBincolulars"
		/>

	</li>

  </ul>

</template>

<script>
import IndentList from './IndentList.vue'
export default {
  name: 'IndentList',
  components: {IndentList},
  props: {
	showHidden: {
		type: Boolean,
		default: true
	},
	children: {
		type: String,
		default: 'children'
	},
	label: {
		type: String,
		default: 'label'
	},
	list: {
		type: Array,
		default: ()=>{ return [] }
	},
	finalActionName: {
		type: String,
		default: ''
	},
	finalAction2Name: {
		type: String,
		default: ''
	},
	finalAction3Name: {
		type: String,
		default: ''
	},
	level: {
		type: Number,
		default: 0
	},
	showBincolulars: {
		type: Boolean,
		default: true
	},
	googleURL: {
		type: String,
		default: ''
	},
	subTabId: {
		type: String,
		default: ''
	},
	highlighted: {
		type: Number,
		default: -1
	},
	highlighted2: {
		type: Number,
		default: -1
	},
	readOnly: {
		type: Boolean,
		default: false
	}
  },
  data() {
    return {
      showFinalAction2: true
    }
  },
  computed: {

	allHidden () {

		return this.list.filter( (item) => {

			return !item.hide;

		} ).length === 0;

	},

	classes () {

		let c = {};

		c['level'+this.level] = true;

		return c;

	},
	hide () {

		return this.subTabId ? ( 'hide-'+this.subTabId ) : 'hide';

	},
	showHidden2 () {

		return this.showHidden;

	}

  },
  methods: {

	finalAction (item) {

		if ( this.finalActionName !== '' ) {

			let n = this.level === 0 ? this.finalActionName : 'finalAction';

			this.$emit(n,item);

		}

	},
	finalAction2 (item,v) {

		if ( this.finalAction2Name !== '' ) {

			let n = this.level === 0 ? this.finalAction2Name : 'finalAction2';

			this.$emit(n,item,v);

		}

	},
	finalAction3 (item) {

		let n = this.level === 0 ? this.finalAction3Name : 'finalAction3';

		this.$emit(n,item);

	}

  }
}
</script>
<style lang="less" scoped>
@import './../../assets/css/less/_settings.less';
ul {

	list-style: none;

	&.level0 {

		padding-left: 0;

	}

	li {

		margin-top: 10px;

		span {

			svg {

				opacity:0.7;
				cursor: pointer;

				&:hover, &.selected {

					opacity: 1;

				}

			}

			&.hide {

				span {

					opacity:0.5;

				}

			}

		}

		&.highlighted {

			background-color: fade( @formDefaultColour, 20 );
			padding: 15px;

		}

	}

	&.hide {

		opacity:0.5;

		li {

			span {

				svg {

					&.eyed {

						display: none;

					}

				}

			}

		}

	}

}
</style>